import useAppSelector from "hooks/useAppSelector"
import { selectEmployeeAddressList } from "store/Employee/address.slice"
import { Table2 } from "components/index"
import AddressModal from "./AddressModal"

const AddressTable = () => {
	const addressList = useAppSelector(selectEmployeeAddressList())
	return (
		<div>
			<Table2
				columns={[
					{ label: "Address", key: "address" },
					{
						label: "Actions",
						key: "action",
						render: data => {
							return <AddressModal resetFields={data.row} />
						},
					},
				]}
				rows={addressList}
			/>
		</div>
	)
}

export default AddressTable
